import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// ── Exact-match redirects ──────────────────────────────────────────────
const REDIRECT_MAP: Record<string, string> = {
  '/om/referenser': '/testimonials',
  '/om/referenser/': '/testimonials',
  '/recensioner': '/testimonials',
  '/recensioner/': '/testimonials',
  // === Legacy main pages ===
  '/hem/affarsnatverk/': '/#tjanster',
  '/hem/affarsnatverk': '/#tjanster',
  '/hem/affärsnatverk/': '/#tjanster',
  '/hem/affärsnatverk': '/#tjanster',
  '/hem/pris': '/#priser',
  '/hem/nyheter/': '/news',
  '/hem/nyheter': '/news',
  '/hem/nyhetsbrev': '/',
  
  '/hem/redovisningshalsokontroll': '/for-foretag',
  '/lokalt-foretagsnatverk': '/foretagsnatverk',
  '/företagsnätverk': '/foretagsnatverk',
  '/kontakt': '/#kontakt',
  '/nyheter': '/news',

  // === Köpa / Sälja byrå legacy (now external → verksamhetsmaklaren.se, see EXTERNAL_REDIRECTS) ===


  // === Driva eget legacy ===
  '/driva_eget/moms': '/momsredovisning-guide',
  '/driva_eget/lonehantering': '/for-foretag',
  '/driva_eget/rapportering': '/for-foretag',
  '/driva_eget/revision': '/for-foretag',
  '/driva_eget/podcast': '/news',
  '/driva_eget/reseavdrag-2024': '/news',
  '/driva_eget/reseavdrag-2024/': '/news',
  // (jämför-priset / bokföringssystem-jämförelser ligger nu externt, se EXTERNAL_REDIRECTS)

  // === Om legacy ===
  // (byrå-partner-sidorna ligger nu på valjredovisningsbyra.se, se EXTERNAL_REDIRECTS)
  '/om/jobba-med-oss': '/om-oss',
  '/om/jobba-med-oss/': '/om-oss',
  '/om/jobba-med-oss/saljkonsult': '/om-oss',
  // (/om/bli-en-samarbetspartner ligger nu externt, se EXTERNAL_REDIRECTS)
  '/om/vart-team': '/om-oss',
  '/om/vart-team/': '/om-oss',
  '/om/vart-team/roger-olsson': '/om-oss',
  
  

  // === Starta eget legacy ===
  '/starta-eget': '/for-foretag',
  '/starta-eget/': '/for-foretag',
  '/starta-eget/mediabyra': '/for-foretag',
  '/starta-eget/en-egen-hemsida': '/for-foretag',

  // === Övriga legacy ===
  '/boka-mote': '/#kontakt',
  // (/jamfor och /jamfor-hotell ligger nu externt, se EXTERNAL_REDIRECTS)
  '/nya-foretagare': '/for-foretag',
  '/ny-startsida': '/',
  
  '/integretetsskydd-cookies-och-gdpr': '/integritetsskydd-cookies-och-gdpr',

  // === Kalkylatorn flyttad under /broker ===
  '/kalkylator': '/broker/kalkylator',
  '/kalkylator/': '/broker/kalkylator',

  // === NYFIKENmodellen Introduktion (ersätter Tillväxtsinsikt) ===
  '/tillvaxtsinsikt': '/nyfikenmodellen-intro',
  '/tillvaxtsinsikt/': '/nyfikenmodellen-intro',

  // === Köp redovisning / Redovisningsförsäljning legacy (now external, see EXTERNAL_REDIRECTS) ===



  // === Hem erbjudanden ===
  '/hem/erbjudanden': '/',
  '/hem/erbjudanden/': '/',
  '/hem/erbjudanden/offerta': '/',
  '/hem/erbjudanden/carzaar': '/',

  // === Nyheter – specific slugs that don't match real news ===
  '/nyheter/one': '/news',
  '/nyheter/jefferson': '/news',
  '/nyheter/moneywise': '/news',
  '/nyheter/deklarationer': '/news',
  '/nyheter/digitala-ekonomihuset': '/news',
  '/nyheter/digital-bokforing': '/news',
  '/nyheter/sell-accounting': '/news',
  '/nyheter/rely-consulting': '/news',
  '/nyheter/bokforing-for-konsulter': '/news',
  '/nyheter/valkommen-thomas-carlsson': '/news',
  '/nyheter/sarskild-delgivningsmottagare': '/news',
  '/nyheter/generationsskifte': '/news',
  '/nyheter/sista-affarsnatverkstraffen': '/news',
  '/nyheter/': '/news',

  // === Blogg legacy ===
  '/blogg/sista-affarsnatverkstraffen': '/news',

  // === Engelska nyheter som inte matchar riktiga artiklar ===
  '/news/welcome-jasmina-egelnor': '/news',
};

// ── Prefix-based wildcard redirects (checked in order) ─────────────────
const PREFIX_REDIRECTS: Array<{ prefix: string; target: string }> = [
  { prefix: '/nyheter/blogg/', target: '/news' },
  { prefix: '/nyheter/', target: '/news' },
  { prefix: '/blogg/', target: '/news' },
  { prefix: '/hem/nyheter/', target: '/news' },
  { prefix: '/hem/erbjudanden/', target: '/' },
  { prefix: '/hem/', target: '/' },
  { prefix: '/driva_eget/', target: '/for-foretag' },
  { prefix: '/starta-eget/', target: '/for-foretag' },
  // '/om/vara-partners/' → byrå-partner-innehåll ligger nu externt, se PREFIX_EXTERNAL_REDIRECTS
  { prefix: '/om/jobba-med-oss/', target: '/om-oss' },
  { prefix: '/om/vart-team/', target: '/om-oss' },
  { prefix: '/om/', target: '/om-oss' },
];

// ── Cross-domain redirects (content moved to another site) ─────────────
const EXTERNAL_REDIRECTS: Record<string, string> = {
  '/tjanster': 'https://valjredovisningsbyra.se/sa-hjalper-vi-foretag',
  '/for-byraer/byrapartner': 'https://valjredovisningsbyra.se/partnerprogram',
  '/for-byraer/partnerbadge': 'https://valjredovisningsbyra.se/partnerprogram',

  // === Hela /for-byraer (säljutbildning för byråer) flyttad till nyfikenmodellen.se ===
  '/for-byraer': 'https://www.nyfikenmodellen.se/redovisning',
  '/for-byraer/': 'https://www.nyfikenmodellen.se/redovisning',
  '/for-byraer/saljutbildning-for-redovisningsbyraer': 'https://www.nyfikenmodellen.se/redovisning',
  '/for-byraer/saljutbildning-for-redovisningsbyraer/': 'https://www.nyfikenmodellen.se/redovisning',
  '/om/bli-en-samarbetspartner': 'https://www.nyfikenmodellen.se/redovisning',
  '/nyfikenmodellen-intro': 'https://www.nyfikenmodellen.se/redovisning',
  '/nyfikenmodellen-intro/': 'https://www.nyfikenmodellen.se/redovisning',

  // === Bokföringssystem-jämförelser flyttade till valjredovisningsbyra.se ===
  '/bokforingssystem': 'https://valjredovisningsbyra.se',
  '/bokforingssystem/': 'https://valjredovisningsbyra.se',
  '/jamfor': 'https://valjredovisningsbyra.se',
  '/jamfor-hotell': 'https://valjredovisningsbyra.se',
  '/driva_eget/jamfor_priset': 'https://valjredovisningsbyra.se',

  // === Behovsguiden och redovisnings-FAQ flyttade till valjredovisningsbyra.se ===
  '/behovsguiden': 'https://valjredovisningsbyra.se',
  '/behovsguiden/': 'https://valjredovisningsbyra.se',
  '/vanliga-fragor': 'https://valjredovisningsbyra.se',
  '/vanliga-fragor/': 'https://valjredovisningsbyra.se',
  '/faq': 'https://valjredovisningsbyra.se',
  '/faq/': 'https://valjredovisningsbyra.se',
  '/driva_eget/jamfor_priset/': 'https://valjredovisningsbyra.se',

  // === Byrå-partner-sidor flyttade till valjredovisningsbyra.se ===
  '/om/vara-partners': 'https://valjredovisningsbyra.se/partners',
  '/om/vara-partners/': 'https://valjredovisningsbyra.se/partners',
  '/om/vara-partners/optisave': 'https://valjredovisningsbyra.se/partners',
  '/om/vara-partners/erbjudanden': 'https://valjredovisningsbyra.se/partners',
  '/om/vara-partners/erbjudanden/': 'https://valjredovisningsbyra.se/partners',
  '/om/partner': 'https://valjredovisningsbyra.se/partners',
  '/bokforingssystem-guide': 'https://valjredovisningsbyra.se/bokforingssystem-guide',
  '/bokforingssystem/guide': 'https://valjredovisningsbyra.se/bokforingssystem-guide',

  // === Köpa / Sälja redovisningsbyrå flyttade till verksamhetsmaklaren.se ===
  '/salja-redovisningsbyra': 'https://verksamhetsmaklaren.se/salja-redovisningsbyra',
  '/kopa-redovisningsbyra': 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra',
  '/l/salja-redovisningsbyra': 'https://verksamhetsmaklaren.se/salja-redovisningsbyra',
  '/l/kopa-redovisningsbyra': 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra',
  '/om/kop-redovisningsuppdrag': 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra',
  '/kop_redovisning': 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra',
  '/kop_redovisning/': 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra',
  '/redovisningsforsaljning': 'https://verksamhetsmaklaren.se/salja-redovisningsbyra',
  '/redovisningsforsaljning/': 'https://verksamhetsmaklaren.se/salja-redovisningsbyra',


  // === Guider flyttade till valjredovisningsbyra.se ===
  '/guider': 'https://valjredovisningsbyra.se/guider',
  '/vad-kostar-redovisning': 'https://valjredovisningsbyra.se/vad-kostar-en-redovisningsbyra',
  '/byta-redovisningsbyra': 'https://valjredovisningsbyra.se/nar-ska-man-byta',
  '/redovisning-vs-bokforing': 'https://valjredovisningsbyra.se/bokforing-vs-redovisning',
  '/valja-redovisningsbyra': 'https://valjredovisningsbyra.se/hur-valjer-man-ratt-redovisningsbyra',
  '/redovisning-enskild-firma': 'https://valjredovisningsbyra.se/redovisningsbyra-enskild-firma',
  '/redovisning-aktiebolag': 'https://valjredovisningsbyra.se/redovisningsbyra-aktiebolag',
  '/auktoriserad-redovisningskonsult': 'https://valjredovisningsbyra.se/auktoriserad-redovisningskonsult',
  '/momsredovisning-guide': 'https://valjredovisningsbyra.se/momsredovisning-guide',
  '/bokslut-arsredovisning': 'https://valjredovisningsbyra.se/arsredovisning-guide',
  '/deklaration-foretag': 'https://valjredovisningsbyra.se/deklaration-foretag',
  '/redovisning-restaurang': 'https://valjredovisningsbyra.se/redovisningsbyra-restaurang',
  '/redovisning-ehandel': 'https://valjredovisningsbyra.se/redovisningsbyra-e-handel',
  '/redovisning-konsult': 'https://valjredovisningsbyra.se/redovisningsbyra-konsult',
  '/redovisning-bygg': 'https://valjredovisningsbyra.se/redovisningsbyra-bygg',

  // === "Hitta redovisningsbyrå" per stad – flyttat till valjredovisningsbyra.se (rollseparation) ===
  '/redovisningsbyra': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-stockholm': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-goteborg': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-malmo': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-uppsala': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-jonkoping': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-linkoping': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-orebro': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-vasteras': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-helsingborg': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-norrkoping': 'https://valjredovisningsbyra.se',
  '/redovisningsbyra-bollnas': 'https://valjredovisningsbyra.se',
  // Legacy interna mål som pekade på den borttagna översikten
  '/hem/accounting': 'https://valjredovisningsbyra.se',
  '/driva_eget/redovisning': 'https://valjredovisningsbyra.se',
  '/driva_eget/redovisning/': 'https://valjredovisningsbyra.se',

  // === /l/ "hitta redovisningsbyrå" (stad + bransch) – flyttat till valjredovisningsbyra.se ===
  '/l/hitta-redovisningsbyra': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-5-saker-viktigare-an-timpris': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-gavle': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-goteborg': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-helsingborg': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-i-orebro': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-jonkoping': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-linkoping': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-lund': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-malmo': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-norrkoping': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-nynashamn': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-sandviken': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-stockholm': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-umea': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-uppsala': 'https://valjredovisningsbyra.se',
  '/l/hitta-redovisningsbyra-vasteras': 'https://valjredovisningsbyra.se',
  '/l/kop-redovisningsuppdrag': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-branscher': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-byggbolag': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-ehandel': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-fastighetsbolag': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-forening-ideell': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-frisor-skonhet-salong': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-handel': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-konsultbolag': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-restaurang': 'https://valjredovisningsbyra.se',
  '/l/redovisningsbyra-transport-logistik': 'https://valjredovisningsbyra.se',

  // === Rollseparation 2026: "för företag"-huvudsida + objektlista flyttade ut ===
  // Objekt (företag till salu) → verksamhetsmaklaren.se
  '/for-foretag/objekt': 'https://verksamhetsmaklaren.se',
  // Huvudsidan "för företag" → valjredovisningsbyra.se
  '/for-foretag': 'https://valjredovisningsbyra.se',

  // === Landningssidor (/l/) flyttade till valjredovisningsbyra.se ===
  '/l/digital-bokforing': 'https://valjredovisningsbyra.se',
  '/l/foretagsnatverk': 'https://valjredovisningsbyra.se',
  '/l/generationsskifte-foretag': 'https://valjredovisningsbyra.se',
  '/l/optisave-affarsnatverket-helhetslosningen-for-foretagare-nar-det-galler-ekonomi-pension': 'https://valjredovisningsbyra.se',

  // === Nyhetsartiklar (redovisningsbyrå-innehåll) flyttade till valjredovisningsbyra.se ===
  '/news/accounting-on-autopilot': 'https://valjredovisningsbyra.se',
  '/news/forsaljning-ar-inget-for-mig-som-konsult-eller': 'https://valjredovisningsbyra.se',
  '/news/how-accountants-and-accounting-firms-can-use-offerta-to-find-new-clients': 'https://valjredovisningsbyra.se',
  '/news/how-to-sell-your-accounting-firm': 'https://valjredovisningsbyra.se',
  '/news/hur-revisorer-och-redovisningsbyraer-kan-anvanda-offerta-for-att-hitta-nya-kunder': 'https://valjredovisningsbyra.se',
  '/news/redovisning-pa-autopilot': 'https://valjredovisningsbyra.se',
  '/news/redovisningsbyraer-fler-stader': 'https://valjredovisningsbyra.se',
  '/news/sa-saljer-du-din-redovisningsbyra': 'https://valjredovisningsbyra.se',
  '/news/sales-are-not-for-me-as-a-consultant-or-are-they': 'https://valjredovisningsbyra.se',
  '/news/the-nyfiken-model-the-training-that-makes-your-agency-more-profitable-and-more-curious': 'https://valjredovisningsbyra.se',
  '/news/vad-kostar-en-redovisningsbyra': 'https://valjredovisningsbyra.se',
  '/news/vilken-foretagsform-passar-dig': 'https://valjredovisningsbyra.se',
  '/news/what-does-an-accounting-firm-cost': 'https://valjredovisningsbyra.se',
  '/news/what-type-of-business-suits-you': 'https://valjredovisningsbyra.se',
  '/news/when-is-a-special-service-recipient-required': 'https://valjredovisningsbyra.se',

  // === Alla individuella byrå-partnersidor (/partners/:slug) flyttade till valjredovisningsbyra.se/partners ===
  // Hanteras nu generellt via PREFIX_EXTERNAL_REDIRECTS ('/partners/') så att även
  // framtida byråer omdirigeras automatiskt. Listvyn /partners stannar kvar (nätverkssponsring).
};

// ── Prefix-based cross-domain redirects (content moved to another site) ─
const PREFIX_EXTERNAL_REDIRECTS: Array<{ prefix: string; target: string }> = [
  { prefix: '/kop_redovisning/', target: 'https://verksamhetsmaklaren.se/kopa-redovisningsbyra' },
  { prefix: '/redovisningsforsaljning/', target: 'https://verksamhetsmaklaren.se/salja-redovisningsbyra' },
  { prefix: '/om/vara-partners/', target: 'https://valjredovisningsbyra.se/partners' },
  { prefix: '/partners/', target: 'https://valjredovisningsbyra.se/partners' },
  { prefix: '/bokforingssystem/', target: 'https://valjredovisningsbyra.se' },
  { prefix: '/for-byraer/', target: 'https://www.nyfikenmodellen.se/redovisning' },
];

// ── Query-param patterns that should redirect to clean URL ─────────────
const STRIP_PARAMS = ['trk', '_escaped_fragment_', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

export const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const searchParams = new URLSearchParams(location.search);

    // 1. Strip tracking / _escaped_fragment_ params → redirect to clean URL
    let hasStrippable = false;
    for (const param of STRIP_PARAMS) {
      if (searchParams.has(param)) {
        searchParams.delete(param);
        hasStrippable = true;
      }
    }
    if (hasStrippable) {
      const cleanUrl = searchParams.toString()
        ? `${currentPath}?${searchParams.toString()}`
        : currentPath;
      console.log(`[SEO] Stripping tracking params → ${cleanUrl}`);
      navigate(cleanUrl, { replace: true });
      return;
    }

    // 2. Normalise trailing slash (except root)
    if (currentPath.length > 1 && currentPath.endsWith('/')) {
      const cleaned = currentPath.slice(0, -1);
      // Only redirect if the cleaned path isn't already in the exact map
      // (the exact map handles some trailing-slash variants itself)
      if (!REDIRECT_MAP[currentPath]) {
        console.log(`[SEO] Trailing slash → ${cleaned}`);
        navigate(cleaned, { replace: true });
        return;
      }
    }

    // 3a. Cross-domain redirect (content moved to another site)
    const externalTarget = EXTERNAL_REDIRECTS[currentPath];
    if (externalTarget) {
      console.log(`[SEO Redirect] ${currentPath} → ${externalTarget}`);
      window.location.replace(externalTarget);
      return;
    }

    // 3b. Cross-domain prefix redirect
    for (const { prefix, target } of PREFIX_EXTERNAL_REDIRECTS) {
      if (currentPath.startsWith(prefix)) {
        console.log(`[SEO Redirect] ${currentPath} → ${target}`);
        window.location.replace(target);
        return;
      }
    }

    // 3. Exact match redirect
    let redirectTo = REDIRECT_MAP[currentPath];

    // 4. Prefix (wildcard) match
    if (!redirectTo) {
      for (const { prefix, target } of PREFIX_REDIRECTS) {
        if (currentPath.startsWith(prefix)) {
          redirectTo = target;
          break;
        }
      }
    }

    if (redirectTo) {
      console.log(`[SEO Redirect] ${currentPath} → ${redirectTo}`);

      if (redirectTo.startsWith('/#')) {
        navigate('/', { replace: true });
        setTimeout(() => {
          window.location.hash = redirectTo.substring(1);
        }, 100);
      } else {
        navigate(redirectTo, { replace: true });
      }
    }
  }, [location.pathname, location.search, navigate]);

  return null;
};
